export const UI_CUSTOMISATION_ROUTES = {
  GENERAL: "/general",
  UI_SETTINGS: "/ui-settings/*",
  ADMIN_PANEL: `/admin-panel`,
  EMAILS: `/emails`,
  // OD-7176 | Remove Third party services tab from Admin panel
  // THIRD_PARTY_SERVICES: `/third-party-services`,
  DYNAMIC_WIDGETS: `/dynamic-widgets`
};

export const UI_SETTINGS_TABS = {
  SIGN_UP: "Sign up",
  LOG_IN: "Log in",
  HOMEPAGE_LAYOUT: "Homepage layout",
  BLOOD_BIOMARKER: "Blood Biomarker",
  DATE_PICKER: "Date picker"
}